const rawApiBaseUrl = process.env.REACT_APP_API_BASE_URL || "http://localhost:4000/api";
const normalizedApiBaseUrl = rawApiBaseUrl.replace(/\/+$/, "");
const API_BASE_URL = normalizedApiBaseUrl.endsWith("/api")
  ? normalizedApiBaseUrl
  : `${normalizedApiBaseUrl}/api`;
const SERVER_BASE_URL = API_BASE_URL.replace(/\/api$/, "");

const AUTH_SESSION_STORAGE_KEY = "puck-pickup-auth-session";

const getStoredAccessToken = () => {
  try {
    const raw = localStorage.getItem(AUTH_SESSION_STORAGE_KEY);
    if (!raw) return null;
    const session = JSON.parse(raw);
    const expiresAt = session?.expiresAt ?? 0;
    const nowSeconds = Math.floor(Date.now() / 1000);
    if (expiresAt - 30 <= nowSeconds) return null;
    return session?.accessToken ?? null;
  } catch {
    return null;
  }
};

async function request(path, options = {}) {
  const token = getStoredAccessToken();
  const headers = {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(options.headers || {}),
  };

  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers,
  });

  let payload;
  try {
    payload = await response.json();
  } catch {
    throw new Error(response.status === 400 ? "Bad request" : "Request failed");
  }

  if (!response.ok || !payload.ok) {
    const message = payload?.error?.message || "Request failed";
    const details = payload?.error?.details;
    const zodMessage =
      details?.issues?.length > 0 ? details.issues.map((i) => i.message).join("; ") : null;
    throw new Error(zodMessage ? `${message}: ${zodMessage}` : message);
  }

  return payload.data;
}

export { API_BASE_URL, SERVER_BASE_URL, request, getStoredAccessToken };
